import { Image } from 'expo-image';
import type { FC } from 'react';
import { useState } from 'react';
import { fitContainer } from 'react-native-zoom-toolkit';

import { BLUR_HASH } from '@/features/media/constants/image';

// Todo: pass thumbHash as param prop to GalleryScreen so that it can be used here
type Props = {
  uri: string;
  containerWidth: number;
  containerHeight: number;
};

export const ZoomImage: FC<Props> = ({
  uri,
  containerWidth,
  containerHeight
}) => {
  const [aspectRatio, setAspectRatio] = useState<number>(1);

  const size = fitContainer(aspectRatio, {
    width: containerWidth,
    height: containerHeight
  });

  return (
    <Image
      accessibilityIgnoresInvertColors
      source={{ uri }}
      placeholder={{ blurhash: BLUR_HASH }}
      style={size}
      contentFit="cover"
      cachePolicy="disk"
      recyclingKey={uri}
      onLoad={(e) => {
        const { width, height } = e.source;
        if (width > 0 && height > 0) {
          setAspectRatio(width / height);
        }
      }}
    />
  );
};
